<script>
import APIUser from '@app/services/API/User';

export default {
  data() {
    return {
      isLoading: false,
      href: '#',
    };
  },
  computed: {
    hasProOrExpertPlan() {
      return this.$store.getters['auth/hasProPlan'] || this.$store.getters['auth/hasExpertPlan'];
    },
  },
  created() {
    if (this.hasProOrExpertPlan) {
      this.getLeClub();
    }
  },
  methods: {
    async getLeClub() {
      this.isLoading = true;

      try {
        const data = await APIUser.getLeClub();

        if (!data || !data.url) {
          this.href = '#';
        } else {
          this.href = data.url;
        }
      } catch (error) {
        this.href = '#';
      } finally {
        this.isLoading = false;
      }
    },
    onClick(event) {
      if (this.isLoading) {
        event.preventDefault();
        return;
      }

      if (!this.hasProOrExpertPlan || this.href === '#') {
        event.preventDefault();
        this.$showMessage.goPro();
      }
    },
  },
};
</script>

<template>
  <a
    v-if="hasProOrExpertPlan"
    class="pr-6"
    :href="href"
    target="_blank"
    rel="noopener noreferrer"
    active-class="is-active"
    @click="onClick($event)"
  >
    <b-icon class="valign-middle" size="is-medium" icon="gift" />
    <span class="valign-middle is-inline-flex is-align-items-center is-justify-content-space-between">
      Le Club <span class="tag is-outlined has-text-weight-medium ml-5">+800 promos</span>
    </span>
  </a>
</template>
